import {getData} from "./APIServiceInterface";

export const getReportListService = async(payload) => {
    const response = getData(`report/getByReportType/?reportType=${payload}`);
    return response;
}
export const reportDownloadData = async(payload) => {
    // const response = getObject(`${payload}`);

    const response = getData(`${payload}`);
    return response;
}